import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {NgModule} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {RouteReuseStrategy} from "@angular/router";

import {AppRoutingModule} from './app-routing.module';

import {AppComponent} from './app.component';
import {CoreModule} from "./core/core.module";
import {AuthTokenInterceptor} from "./interceptors/auth-token.interceptor";
import {ETagInterceptor} from "./interceptors/e-tag.interceptor";
import {MainComponent} from './main/main.component';
import {CacheRouteReuseStrategy} from "./race/cache-router-reuse-strategy";


@NgModule({
  declarations: [
    AppComponent,
    MainComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    CoreModule,
    FormsModule,
    AppRoutingModule
  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthTokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ETagInterceptor,
      multi: true
    }
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts